import { combineReducers } from 'redux'
import { AppAction, AppState } from '../types'
import configurationReducer from './configurationReducer'
import dataReducer from './dataReducer'
import uiReducer from './uiReducer'

const mainReducer = combineReducers<AppState, AppAction>({
  data: dataReducer,
  configuration: configurationReducer,
  ui: uiReducer
})

export default mainReducer
